import { initializeApp } from "firebase/app"

const firebaseConfigDev = {
  apiKey: "AIzaSyCpAlVlHJqbiYwTLvIzeWh9LFeZCH4hdfs",
  authDomain: "fab-i-bet-dev.firebaseapp.com",
  projectId: "fab-i-bet-dev",
  storageBucket: "fab-i-bet-dev.appspot.com",
  messagingSenderId: "1068968711769",
  appId: "1:1068968711769:web:426509b5a0b9bc3e35c348",
  databaseURL: "https://fab-i-bet-dev-default-rtdb.europe-west1.firebasedatabase.app"
};

const firebaseConfigProd = {
  apiKey: "AIzaSyBadUi9DDuC_zOHLjg3AOlBHfEqU1OqIdg",
  authDomain: "fab-i-bet-production.firebaseapp.com",
  databaseURL: "https://fab-i-bet-production-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "fab-i-bet-production",
  storageBucket: "fab-i-bet-production.appspot.com",
  messagingSenderId: "194104061022",
  appId: "1:194104061022:web:030f5377fbbb20eab598cf"
};


// Initialize Firebase
const app = initializeApp(firebaseConfigProd);
export default app

 
